<button kendoButton size="large" class="button" (click)="this.open()">{{this.label()}}</button>
<kendo-dialog *ngIf="isEditing" title="{{this.label()}}" width="550px" [height]="'auto'" [maxHeight]="'95%'" (close)="this.close();" >
    @for (ld of this.losDefs(); track ld.index) {
    <los-def-editor [editOnly]="false" [ldType]="this.type()" [initialValue]="ld" [class.led-even]="$even"
        [class.led-odd]="$odd" class="mouse-over" />

    }

</kendo-dialog>